import { render, staticRenderFns } from "./SpecificationPanel.vue?vue&type=template&id=f391857c&"
import script from "./SpecificationPanel.vue?vue&type=script&lang=js&"
export * from "./SpecificationPanel.vue?vue&type=script&lang=js&"
import style0 from "./SpecificationPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports